var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hit"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"hit__body"},[_c('div',{staticClass:"hit__title",domProps:{"innerHTML":_vm._s(_vm.$t('affiliates.hit_title'))}}),_c('div',{staticClass:"hit__subtitle"},[_vm._v(" "+_vm._s(_vm.$t('affiliates.hit_text'))+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }